<script setup lang="ts">
import { TicketSubject } from '@libero/api-client/ticket-subject/types';
import Button from '@libero/ui-framework/Button/Button.vue';
import Cluster from '@libero/ui-framework/Cluster/Cluster.vue';
import Modal from '@libero/ui-framework/Modal/Modal.vue';
import ModalContent from '@libero/ui-framework/Modal/ModalContent.vue';
import Stack from '@libero/ui-framework/Stack/Stack.vue';
import Typography from '@libero/ui-framework/Typography/Typography.vue';
import { useI18n } from 'vue-i18n';

interface Props {
  ticketSubject: TicketSubject;
  isOpen: boolean;
  onCancel: () => void;
  onReplace: () => void;
}

defineProps<Props>();

const { t } = useI18n();
</script>

<template>
  <Modal :isOpen="isOpen" :title="t('citizen-report.replace-container-title')" :onCancel="onCancel">
    <ModalContent>
      <Stack :gap="2">
        <Typography size="lg">
          <span
            v-html="
              t('citizen-report.one-container-allowed', { ticketSubject: ticketSubject.name })
            "
          />
        </Typography>

        <Cluster justifyContent="end">
          <Button appearance="outline" :onClick="onCancel">
            {{ t('cancel') }}
          </Button>

          <Button :label="t('replace')" :onClick="onReplace" />
        </Cluster>
      </Stack>
    </ModalContent>
  </Modal>
</template>
